<template>
    <div>
        <div @click="handleGoDetail(subMsgComputed.link)" style="cursor: pointer;">
            <!-- <div class="img_c">
                <img :src="subMsgComputed.cover" />
            </div> -->
            <video width="320" height="240" controls :poster="subMsgComputed.cover" preload="none">
                <source :src="subMsgComputed.link" type="video/mp4">
                您的浏览器不支持视频标签。
            </video>
            <div class="msg_c mt_10">
                [视频消息]
            </div>

        </div>
    </div>
</template>
<script>
// 引入动态组件（中间栏）
import { toRefs, onMounted, reactive, computed, inject } from "vue";
export default {
    components: {},
    setup() {
        const $tauriWindow = inject('tauriWindow')
        const msgItem = inject('msgItem')
        const data = reactive({

        });
        const subMsgComputed = computed(() => {
            try {
                return JSON.parse(msgItem?.submsg)
            } catch (e) {
                console.error(e)
                return {}
            }
        })
        // ----------- 方法 -----------
        const handleGoDetail = (url) => {
            if (!url) {
                return
            }
            $tauriWindow.openWindow(url)
        }

        onMounted(() => { });


        return {
            ...toRefs(data),
            msgItem,
            subMsgComputed,
            handleGoDetail
        };
    },
};
</script>

<style lang="scss" scoped>
.img_c {
    display: flex;
    justify-content: flex-end;
}

.img_c img {

    width: 200px;
    height: 200px;
    object-fit: fill;
}

.msg_c {
    display: flex;
    justify-content: center;
}
</style>